import { DEFAULT_POST_LOGIN_REDIRECT_PATH, ensureSafeRedirectPath } from './sso';

interface LocationLike {
  pathname?: string;
  search?: string;
  hash?: string;
}

interface LoginRedirectOptions {
  orgId?: string | null;
}

export const buildRequestedUrl = ({ pathname, search, hash }: LocationLike): string => {
  const safePathname = pathname && pathname.length > 0 ? pathname : DEFAULT_POST_LOGIN_REDIRECT_PATH;
  return `${safePathname}${search ?? ''}${hash ?? ''}`;
};

export const buildLoginRedirectPath = (locationLike: LocationLike, options?: LoginRedirectOptions): string => {
  const params = new URLSearchParams();
  const orgId = options?.orgId?.trim();
  if (orgId) {
    params.set('orgId', orgId);
  }
  params.set('redirect', buildRequestedUrl(locationLike));
  return `/login?${params.toString()}`;
};

export const resolvePostLoginRedirectPath = (redirect?: string | null): string => ensureSafeRedirectPath(redirect);
